if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.oneTimePriceObserver?.disconnect();
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
            this.alignOneTimePrice();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // am-v1 template only: the product page wraps the Recharge one-time price in
      // span.rc-price on DOMContentLoaded so it aligns right. That never runs in the
      // popup, so do it here once, then keep the span in sync on variant change.
      alignOneTimePrice() {
        const productInfo = this.modalContent.querySelector('product-info.am-v1-product');
        if (!productInfo) return;

        const labelSelector = '.rc-template__radio .onetime-radio .rc-radio__label';

        const splitLabel = (label) => {
          const match = label.textContent.match(/\$[\d,]+\.\d{2}/);
          if (!match) return false;
          const text = label.textContent.replace(match[0], '').trim();
          label.innerHTML = `${text} <span class="rc-price">${match[0]}</span>`;
          return true;
        };

        // Recharge renders the widget after the popup opens: wait for the label,
        // split it once and stop observing.
        this.oneTimePriceObserver?.disconnect();
        const trySplit = () => {
          const label = productInfo.querySelector(labelSelector);
          if (label && (label.querySelector('.rc-price') || splitLabel(label))) {
            this.oneTimePriceObserver?.disconnect();
            return true;
          }
          return false;
        };
        if (!trySplit()) {
          this.oneTimePriceObserver = new MutationObserver(trySplit);
          this.oneTimePriceObserver.observe(productInfo, { childList: true, subtree: true });
        }

        if (this.oneTimePriceUnsubscribe || typeof subscribe !== 'function') return;
        this.oneTimePriceUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          const currentInfo = this.modalContent.querySelector('product-info.am-v1-product');
          const priceEl = currentInfo?.querySelector(`${labelSelector} .rc-price`);
          const priceWrap = currentInfo?.querySelector('[id^="price-"] .price');
          if (!priceEl || !priceWrap) return;

          const onSale = priceWrap.classList.contains('price--on-sale');
          const priceItem =
            (onSale && priceWrap.querySelector('.price__sale .price-item--sale')) ||
            priceWrap.querySelector('.price__regular .price-item--regular');
          const price = priceItem?.textContent.trim();
          if (price) priceEl.textContent = price;
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
